<template>
  <div class="bg-white">
    <div class="nav_big_screen">
      <div
        class="container d-flex align-items-center justify-content-between border_header"
      >
        <ul class="nav-container my-1">
          <li>
            <router-link class="header-nav" to="/">
              {{ $t("home") }}</router-link
            >
          </li>
          <li>
            <b-dropdown
              :class="{
                'active-dropdown':
                  $route.path.includes('about-ministry') ||
                  $route.path.includes('about-platform'),
              }"
              class="header-menu"
              :text="$t('about')"
              variant="flat-primary"
            >
              <b-dropdown-item to="/about-ministry"
                >{{ $t("aboutMinistry") }}
              </b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/about-platform">
                {{ $t("aboutPlatform") }}</b-dropdown-item
              >
            </b-dropdown>
          </li>
          <li>
            <b-dropdown
              :class="{
                'active-dropdown':
                  $route.path.includes('ngo-law') ||
                  $route.path.includes('standard-guide') ||
                  $route.path.includes('decisions') ||
                  $route.path.includes('ngo-related-laws') ||
                  $route.path.includes('circulars'),
              }"
              class="header-menu"
              :text="$t('govInfo')"
              variant="flat-primary"
            >
              <b-dropdown-item to="/legal-references/laws">
                {{ $t("ngoOrgLaw") }}</b-dropdown-item
              >
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/decrees"
                >القوانين والمراسيم المرتبطة بعمل المنظمات غير
                الحكومية</b-dropdown-item
              >
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/circulars">
                التعاميم
              </b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/decisions">
                القرارات
              </b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/systems"
                >الأنظمة و الأدلة</b-dropdown-item
              >
            </b-dropdown>
          </li>
          <li>
            <b-dropdown
              :class="{
                'active-dropdown':
                  $route.path.includes('ngo-list') ||
                  $route.path.includes('ngos-map'),
              }"
              class="header-menu"
              text="المنظمات"
              variant="flat-primary"
            >
              <b-dropdown-item to="/ngo-list">
                {{ $t("ngoList") }}</b-dropdown-item
              >
              <hr class="m-0" />
              <b-dropdown-item to="/ngos-map"> {{ $t("map") }}</b-dropdown-item>
            </b-dropdown>
          </li>
          <li>
            <router-link class="header-nav" to="/donation">
              {{ $t("donationCampains") }}</router-link
            >
          </li>
          <li>
            <b-dropdown
              :class="{
                'active-dropdown': $route.path.includes('earthquakes'),
              }"
              class="header-menu"
              text="الاستجابات الطارئة"
              variant="flat-primary"
            >
              <b-dropdown-item to="/ramadanCampaign">
                حملة رمضان
              </b-dropdown-item>
              <b-dropdown-item to="/earthquakes">
                استجابة الزلازل
              </b-dropdown-item>
            </b-dropdown>
          </li>
          <li>
            <router-link class="header-nav" to="/general-activities">
              {{ $t("eventsAndAnniversaries") }}</router-link
            >
          </li>
          <li>
            <b-dropdown
              class="header-menu"
              :class="{
                'active-dropdown':
                  $route.path.includes('jobs') ||
                  $route.path.includes('volunteer'),
              }"
              :text="$t('joinUs')"
              variant="flat-primary"
            >
              <b-dropdown-item to="/jobs">{{ $t("jobsVac") }}</b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/volunteer"
                >{{ $t("VolunteerOp") }}
              </b-dropdown-item>
            </b-dropdown>
          </li>
        </ul>
        <div class="d-flex">
          <b-button
            @click="$router.push('/ngo-create-steps')"
            class="header-button"
            size="sm"
            variant="info"
          >
            <feather-icon icon="FileIcon" size="16" />
            <span> {{ $t("createNgo") }} </span>
          </b-button>
          <a href="/auth/login">
            <b-button class="header-button" size="sm" variant="primary">
              <feather-icon icon="LogInIcon" size="16" />
              <span> {{ $t("login") }} </span>
            </b-button>
          </a>
        </div>
      </div>
    </div>
    <div>
      <header-small-screen></header-small-screen>
    </div>
  </div>
</template>

<script>
import CollapseHeader from "@core/components/app-collapse/CollapseHeader.vue";

import {
  BDropdown,
  BDropdownItem,
  BButton,
  BListGroupItem,
  BListGroup,
  BNav,
  BNavItem,
} from "bootstrap-vue";
import HeaderSmallScreen from "./HeaderSmallScreen.vue";
export default {
  components: {
    BButton,
    BNav,
    BNavItem,
    BDropdown,
    BDropdownItem,
    BButton,
    CollapseHeader,
    BListGroupItem,
    BListGroup,
    HeaderSmallScreen,
  },
  data() {
    return {
      show: false,
    };
  },

  methods: {
    handlShow(reverseShow) {
      this.show = reverseShow;
    },
  },
};
</script>

<style lang="scss">
.header-menu {
  .btn {
    padding-left: 8px;
  }
}
.header-nav {
  text-transform: capitalize;
  white-space: nowrap;
}
.dropdown-toggle {
  text-transform: capitalize;

  direction: rtl;
  &:after {
    margin-right: 3px;
  }
}
</style>
